import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { fetchCandidateResponse, getCandidateResumeByFileUrl } from 'wisestep-api';

const useGetCandidateSummary = (
  resumeLocation: string,
  jobDescription: string,
  existedSummary: string
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [candidateSummary, setCandidateSummary] = useState<string>(existedSummary ?? '');
  const updateCandidateSummary = (data: string) => setCandidateSummary(data);
  useEffect(() => {
    isEmpty(candidateSummary) &&
      (async () => {
        try {
          setLoading(true);
          const res = await getCandidateResumeByFileUrl(resumeLocation ?? '');
          const response = await fetchCandidateResponse({
            resumeContent: res.data?.content,
            jobDescription: jobDescription ?? '',
          });
          setCandidateSummary(response?.data);
        } catch (e) {
          console.error('Error while getting the Candidate summary', e);
        } finally {
          setLoading(false);
        }
      })();
  }, [resumeLocation, jobDescription, candidateSummary]);

  return { candidateSummary, loading, updateCandidateSummary };
};

export default useGetCandidateSummary;
